module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("foD9Q"))).then(() => parcelRequire('1iHdE'));